module.exports = __webpack_public_path__ + "static/purple_worm-14ba026cf76592c97d9dea5980df20c2.jpeg";